/**
 * Styled console banner for developers who open DevTools.
 * For Media Devoted | Created By Ciro Autiero
 */

const LOGO = String.raw`
 ████████╗██████╗  █████╗ ███████╗███████╗██╗ ██████╗
 ╚══██╔══╝██╔══██╗██╔══██╗██╔════╝██╔════╝██║██╔════╝
    ██║   ██████╔╝███████║█████╗  █████╗  ██║██║
    ██║   ██╔══██╗██╔══██║██╔══╝  ██╔══╝  ██║██║
    ██║   ██║  ██║██║  ██║██║     ██║     ██║╚██████╗
    ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝     ╚═╝     ╚═╝ ╚═════╝
 ██████╗ ██╗   ██╗██╗     ███████╗███████╗
 ██╔══██╗██║   ██║██║     ██╔════╝██╔════╝
 ██████╔╝██║   ██║██║     ███████╗█████╗
 ██╔═══╝ ██║   ██║██║     ╚════██║██╔══╝
 ██║     ╚██████╔╝███████╗███████║███████╗
 ╚═╝      ╚═════╝ ╚══════╝╚══════╝╚══════╝`.trim();

const CREDIT = 'Created by Ciro Autiero for Media Devoted';

let printed = false;

export function printTrafficPulseDevtoolsBanner(): void {
  if (printed || typeof console === 'undefined') return;
  printed = true;

  const brand =
    'color:#818cf8;font-weight:700;font-size:13px;line-height:1.15;font-family:Menlo,Monaco,Consolas,monospace';
  const muted = 'color:#94a3b8;font-size:12px;font-family:system-ui,sans-serif';
  const accent = 'color:#e2e8f0;font-weight:600;font-size:12px;font-family:system-ui,sans-serif';
  const fine = 'color:#64748b;font-size:11px;line-height:1.5;font-family:system-ui,sans-serif';

  console.log(`%c${LOGO}`, brand);
  console.log(`%c${CREDIT}`, muted);
  console.log('%cYes — we can see you.', accent);
  console.log(
    '%cYou opened DevTools. That usually means you ship code, chase a bug, or someone told you to paste a "fix" here.\n' +
      'If you are on the TrafficPulse team: welcome. Break things in dev, not in prod.\n' +
      'If you are not: close this tab and do not run scripts from strangers.',
    fine,
  );
}
